import { CommitmentEventDetail } from '../../../components/Commitment';

export function CommitmentEvent() {
  return <CommitmentEventDetail />;
}
